import { create } from 'zustand';

export enum DETAIL_MODAL_TYPE {
  FEEDBACK = 'feedback',
  COMPANY = 'company',
  CUSTOMER = 'customer',
  DASHBOARD = 'dashboard',
  AGENT = 'agent',
  CHART = 'chart',
  SEARCH_SUMMARY = 'search-summary',
  FEEDBACK_LIST = 'feedback-list',
  FEEDBACK_BLOCK_LIST = 'feedback-block-list',
  CHART_ANALYSIS = 'chart-analysis',
  STATIC_FEEDBACK = 'static-feedback',
  HEY_SYNCLY_MENTION_LIST = 'hey-syncly-mention-list',
  CATEGORY_MENTION_LIST = 'category-mention-list',
}

export type DetailModalOptions<T> = T;

export type DetailModalT = {
  alias: string;
  keys?: string[];
  type: DETAIL_MODAL_TYPE;
  options?: DetailModalOptions<any>;
};

export type SetNewModalParams<T extends {}> = {
  alias: string;
  type: DETAIL_MODAL_TYPE;
  idx?: number;
  options?: DetailModalOptions<T>;
  keys?: any[];
};

type State = {
  modalStack: DetailModalT[];
};

type Action = {
  checkModalstack: () => boolean;
  setNewModal: <T extends {}>(params: SetNewModalParams<T>) => void;
  setModalStack: (type: DETAIL_MODAL_TYPE) => void;
  closeModal: (modalId?: string) => void;
  initModal: () => void;
};

const initialState: State = {
  modalStack: [],
};

const useDetailModalStore = create<State & Action>((set, get) => ({
  ...initialState,
  checkModalstack: () => {
    const modalStack = get().modalStack;
    return modalStack.length > 1;
  },
  setNewModal: (params) => {
    const { alias, type, idx, options, keys } = params;
    const newModalStack = [...get().modalStack];
    const modalStack = get().modalStack;
    const len = modalStack.length;

    for (let i = 0; i < len; i++) {
      const currentModal = modalStack[i];
      if (!currentModal) continue;
      if (
        JSON.stringify({
          alias,
          type,
          keys,
        }) ===
        JSON.stringify({
          alias: currentModal.alias,
          type: currentModal.type,
          kyes: currentModal.keys,
        })
      ) {
        //이미 열려있는 모달인 경우
        return;
      }
    }
    if (typeof idx === 'undefined') {
      if (len === 3) {
        //3단까지 존재하는 경우
        newModalStack.shift();
        newModalStack.push({ alias, type, options });
      } else {
        //모달이 생성 될 단(idx)에 모달이 존재하는 경우
        newModalStack[len] = {
          alias,
          type,
          options,
        };
      }
    } else {
      newModalStack[idx] = {
        alias,
        type,
        options,
      };
    }

    set({ modalStack: newModalStack });
  },
  setModalStack: (type) => {
    const newStack = [...get().modalStack].filter((stack) => stack.type === type);
    set((state) => ({
      ...state,
      modalStack: newStack,
    }));
  },
  closeModal: (modalId) => {
    let newModalStack: DetailModalT[] = [...get().modalStack];
    if (modalId) {
      newModalStack = newModalStack.filter(
        (modal) =>
          JSON.stringify({
            alias: modal.alias,
            type: modal.type,
            keys: modal.keys,
          }) !== modalId,
      );
    } else {
      newModalStack.pop();
    }

    set((state) => ({
      ...state,
      modalStack: newModalStack,
    }));
  },
  initModal: () => {
    set((state) => initialState);
  },
}));

export default useDetailModalStore;
